namespace Serenity.EmailClient {

    import UI = Serenity.UI;

    const quickSettingsItems = [
        {
            value: "custom",
            text: "Custom",
            settings: {
                ImapHost: "",
                ImapPort: 993,
                ImapUsername: "",
                SmtpHost: "",
                SmtpPort: 465,
                SmtpUsername: "",
            }
        },
        {
            value: "gmail",
            text: "Gmail",
            settings: {
                ImapHost: "imap.gmail.com",
                ImapPort: 993,
                ImapUsername: "yourusername@gmail.com",
                SmtpHost: "smtp.gmail.com",
                SmtpPort: 465,
                SmtpUsername: "yourusername@gmail.com",
            }
        },
        {
            value: "outlook",
            text: "Outlook / Hotmail",
            settings: {
                ImapHost: "imap-mail.outlook.com",
                ImapPort: 993,
                ImapUsername: "yourusername@outlook.com",
                SmtpHost: "smtp-mail.outlook.com",
                SmtpPort: 587,
                SmtpUsername: "yourusername@outlook.com",
            }
        },
        {
            value: "yandex",
            text: 'Yandex',
            settings: {
                ImapHost: "imap.yandex.com",
                ImapPort: 993,
                ImapUsername: "yourusername@yandex.com",
                SmtpHost: "smtp.yandex.com",
                SmtpPort: 465,
                SmtpUsername: "yourusername@yandex.com",
            }
        }
    ];

    export class MailboxLoginProps {
        onLogin: () => void;
    }

    export class MailboxLoginView extends React.Component<MailboxLoginProps> {

        private editorRefs = new UI.EditorRefs();

        private loadQuickSettings(value: string) {
            var item = Q.tryFirst(quickSettingsItems, x => x.value == value);
            if (item)
                this.editorRefs.loadFrom(item.settings, Object.keys(item.settings));
        }

        handleQuickSettingChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
            this.loadQuickSettings(e.target.value);
        }

        componentDidMount() {
            this.loadQuickSettings("gmail");
        }

        login() {
            var loginInfo: EmailLoginInfo = {};
            this.editorRefs.saveTo(loginInfo);
            delete loginInfo["QuickSettings"];
            EmailService.Login({
                LoginInfo: loginInfo
            }, response => {
                this.props.onLogin();
            });
        }

        private form: UI.Form;

        render(): React.ReactNode {
            var lt = (key: string) => Q.text("Site.EmailClient." + key);
            var fieldProps = (name: string) => ({ name: name, caption: lt(name), setRef: this.editorRefs.set });
            return (
                <div className="s-MailboxLoginView">
                    <div className="row">
                        <div className="col-md-4">
                        </div>

                        <div className="col-md-4">
                            <UI.Form ref={el => this.form = el}>
                                <div className="box box-solid login-view-box">
                                    <div className="box-header with-border">
                                        <h3 className="box-title">{Q.text("Site.EmailClient.LoginTitle")}</h3>
                                    </div>
                                    <div className="box-body">
                                        <UI.PropertyGrid>

                                            <UI.Field name="QuickSettings" caption={lt("QuickSettings")}
                                                editor={edProps =>
                                                    <select name={edProps.name} ref={edProps.ref} defaultValue="gmail"
                                                        onChange={this.handleQuickSettingChange}>
                                                        {quickSettingsItems.map(x =>
                                                            <option key={x.value} value={x.value}>{x.text}</option>)}
                                                    </select>} />

                                            <UI.Field {...fieldProps("ImapHost") } required
                                                editor={edProps => <StringEditor {...edProps} />} />

                                            <UI.Field {...fieldProps("ImapPort") } required
                                                editor={edProps => <IntegerEditor {...edProps} />} />

                                            <UI.Field {...fieldProps("ImapUsername") } required
                                                editor={edProps => <StringEditor {...edProps}
                                                    onChange={e => this.editorRefs.get("SmtpUsername").value =
                                                        this.editorRefs.get("ImapUsername").value} />} />

                                            <UI.Field {...fieldProps("ImapPassword") } required
                                                editor={edProps => <PasswordEditor {...edProps}
                                                    onChange={e => this.editorRefs.get("SmtpPassword").value =
                                                        this.editorRefs.get("ImapPassword").value} />} />

                                            <UI.Field {...fieldProps("SmtpHost") } required
                                                editor={edProps => <StringEditor {...edProps} />} />

                                            <UI.Field {...fieldProps("SmtpPort") } required
                                                editor={edProps => <IntegerEditor {...edProps} />} />

                                            <UI.Field {...fieldProps("SmtpUsername") } required
                                                editor={edProps => <StringEditor {...edProps} />} />

                                            <UI.Field {...fieldProps("SmtpPassword") } required
                                                editor={edProps => <PasswordEditor {...edProps} />} />

                                        </UI.PropertyGrid>
                                    </div>
                                    <div className="box-footer" style={{ marginBottom: "10px" }}>
                                        <button className="btn btn-success" onClick={e => this.form.validateForm() && this.login()} type="button">
                                            {Q.text("Site.EmailClient.LoginButton")}
                                        </button>
                                    </div>
                                </div>
                            </UI.Form>
                        </div>

                        <div className="col-md-4">
                        </div>
                    </div>
                </div>
            );
        }
    }
}